import { deliveryEndpoint } from '../scheduling/api';
import { createContext, useContext } from 'react';
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import * as api from '../config/api';
import { resolveSessionForType } from '../../../auth/resolveSession';

const authorRuntime = {
  deliveryEndpoint: deliveryEndpoint(),
  api,
  async readIdentity({ forceRefresh = false } = {}) {
    const result = await resolveSessionForType('author', { restore: true, read: async () => {
      const session = await fetchAuthSession({ forceRefresh });
      return { session, attributes: await fetchUserAttributes() };
    } });
    const token = result.data.session.tokens?.idToken?.toString();
    if (!result.data.attributes?.sub || !token) throw new Error('Please return to Author Login and try again.');
    return { attributes: result.data.attributes, token };
  },
  fetch: (...args) => fetch(...args),
  fetchAuthSession,
  fetchUserAttributes,
  getIdToken: api.getRequiredIdToken,
  getRequiredIdToken: api.getRequiredIdToken,
  composerUrl: '/authorportal/newslettercomposer',
  mailCenterUrl: '/authorportal/mailcenter',
  portalUrl: '/authorportal/mainpage',
  storageScope: '',
};
const MailRuntime = createContext(authorRuntime);
export const MailRuntimeProvider = MailRuntime.Provider;
export const useMailRuntime = () => useContext(MailRuntime);
